import { createReducer, requestStatus } from '../../lib/Utils'
import {
  VALIDATE_AUTH_FULFILLED,
  VALIDATE_AUTH_REJECTED,
  SIGN_IN,
  SIGN_IN_FULFILLED,
  SIGN_IN_REJECTED,
  RESET_PASSWORD,
  RESET_PASSWORD_FULFILLED,
  RESET_PASSWORD_REJECTED,
  REQUEST_ACCESS,
  REQUEST_ACCESS_FULFILLED,
  REQUEST_ACCESS_REJECTED,
  GET_JWT_FROM_ACCESS_TOKEN_FULFILLED,
  GET_STORED_JWT_FULFILLED,
  CLEAR_JWT_FULFILLED,
  SET_AUTH_HEADERS,
  ADD_JWT_TO_STATE,
  SIGN_OUT,
} from './actions'

const initialState = {}

export const GENERIC_ERROR_MSG = 'Request failed'

export default createReducer(initialState, {
  [VALIDATE_AUTH_FULFILLED]: (state, action) => {
    const newState = { ...state, ...action.payload }
    return newState
  },
  [VALIDATE_AUTH_REJECTED]: (state) => {
    //Remove user object if we are rejected
    return { ...state, user: null }
  },
  [SIGN_IN]: (state) => {
    return { ...state, signInStatus: requestStatus.pending }
  },
  [SIGN_IN_FULFILLED]: (state, action) => {
    const newState = {
      ...state,
      signInStatus: requestStatus.complete,
      signInErrors: null,
      ...action.payload,
    }
    return newState
  },
  [SIGN_IN_REJECTED]: (state, action) => {
    let errors
    if (action.payload && action.payload.errors) {
      errors = action.payload.errors
    } else {
      errors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      signInStatus: requestStatus.rejected,
      user: null,
      signInErrors: errors,
    }
    return newState
  },
  [RESET_PASSWORD]: (state) => {
    return { ...state, resetPasswordStatus: requestStatus.pending }
  },
  [RESET_PASSWORD_FULFILLED]: (state) => {
    return { ...state, resetPasswordStatus: requestStatus.complete }
  },
  [RESET_PASSWORD_REJECTED]: (state) => {
    return { ...state, resetPasswordStatus: requestStatus.rejected }
  },
  [REQUEST_ACCESS]: (state) => {
    return {
      ...state,
      requestAccessStatus: requestStatus.pending,
      requestAccessErrors: null,
    }
  },
  [REQUEST_ACCESS_FULFILLED]: (state, action) => {
    return {
      ...state,
      requestAccessStatus: requestStatus.complete,
      requestAccessErrors: null,
      ...action.payload,
    }
  },
  [REQUEST_ACCESS_REJECTED]: (state, action) => {
    let requestAccessErrors
    if (action.payload && action.payload.errors) {
      requestAccessErrors = action.payload.errors
    } else {
      requestAccessErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      requestAccessStatus: requestStatus.rejected,
      user: null,
      requestAccessErrors,
    }
    return newState
  },
  [GET_JWT_FROM_ACCESS_TOKEN_FULFILLED]: (state, action) => {
    const newState = { ...state, jwt: action.payload.response.jwt }
    return newState
  },
  [GET_STORED_JWT_FULFILLED]: (state, action) => {
    const newState = { ...state, ...action.payload }
    return newState
  },
  [CLEAR_JWT_FULFILLED]: (state) => {
    return { ...state, jwt: null, headers: null }
  },
  [SET_AUTH_HEADERS]: (state, action) => {
    return { ...state, ...action.payload }
  },
  [ADD_JWT_TO_STATE]: (state, action) => {
    return { ...state, ...action.payload }
  },
  [SIGN_OUT]: () => {
    return initialState
  },
})
